if (!customElements.get('login-form')) {
  class Login extends HTMLElement {
    constructor() {
      super();
      this.accountUrl = this.dataset.accountUrl;
    }

    connectedCallback() {
      this.addDelegatedClickListeners();
      this.addDeligatedEventListeners();
    }

    addDelegatedClickListeners() {

      this.addEventListener('click', (e) => {
        const clickedElement = e.target.closest('[data-account-action]');
        if (!clickedElement) return;
        
        const { 
          accountAction: action,
          accountTarget
        } = clickedElement.dataset;

        switch (action) {
          case 'toggle-section':  
            [...this.querySelectorAll('[data-account-action]')].forEach(btn => {
              btn.dataset.accountTarget === accountTarget ? btn.setAttribute('disabled', true) : btn.removeAttribute('disabled', true); 
            });
            [...this.querySelectorAll('[data-account-section]')].forEach(section => {
              section.dataset.accountSection === accountTarget ? section.classList.remove('hidden') : section.classList.add('hidden'); 
            });
            trapFocusInDialog(this);  
          break;
          default: break;
        }
      })
    }
    addDeligatedEventListeners () {
      window.addEventListener('DOMContentLoaded', () => {
        const hash = window.location.hash;
        hash === '#reset_password' || hash === '#recover' ? document.querySelector('[data-account-target="reset"]').click() : null;
      })
    }
  }

  customElements.define('login-form', Login);
}